export const KEY_CODES = {
  SPACE: 32,
  PERCENT_SIGN: 37,
  AMPERSAND: 38,
  APOSTROPHE: 39,
  LEFT_PARENTHESIS: 40,
  DIGIT_1: 49,
  DIGIT_2: 50,
  DIGIT_3: 51
}
